import React from "react";
import { WifiOff, RefreshCw, Smartphone, Shield } from "lucide-react";
import { Button } from "@/common/components/ui/button";

/**
 * Shown when the app cannot reach backend APIs because the user's
 * network provider blocks the connection (e.g. DNS / firewall on some ISPs).
 */
const ConnectionIssuesPage = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4 text-center">
      <div className="mx-auto w-full max-w-lg space-y-8">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-amber-100">
          <WifiOff className="h-12 w-12 text-amber-600" />
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Connection Not Established
          </h1>
          <p className="text-lg text-gray-600">
            We could not connect to our servers from your current network.
          </p>
          <p className="text-base text-gray-600">
            This usually happens when{" "}
            <span className="font-medium text-gray-800">
              your network provider blocks access
            </span>
            . The platform is working fine on other networks.
          </p>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm">
          <h2 className="mb-4 text-base font-semibold text-gray-900">
            What you can try
          </h2>
          <ul className="space-y-4">
            <li className="flex gap-3">
              <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-50">
                <Smartphone className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <p className="font-medium text-gray-900">Change your network</p>
                <p className="text-sm text-gray-600">
                  Switch to mobile data, another Wi‑Fi, or a different network
                  provider, then open this page again.
                </p>
              </div>
            </li>
            <li className="flex gap-3">
              <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-50">
                <Shield className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <p className="font-medium text-gray-900">Use a VPN</p>
                <p className="text-sm text-gray-600">
                  Connect with a VPN provider, then refresh this page to use the
                  platform.
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center gap-3">
          <Button onClick={handleRetry} className="min-w-[180px]">
            <RefreshCw className="mr-2 h-4 w-4" />
            Try again
          </Button>
          <p className="text-sm text-gray-500">
            Once you are on a different network or VPN, tap Try again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConnectionIssuesPage;
